<template>
  <div class="container complete_surah_cont">
    <div class="row m-0">
      <div class="col-lg-2 p-0 columnAside">
        <surah-selection @changeSurah="changeSurah"></surah-selection>
        <div class="columnLeftSub">
          <div class="columnLeftContent">
            <!-- <div class="transCheckBoxes">
              <translation-checks></translation-checks>
            </div> -->
            <div class="zoomingButtons">
              <zooming-function></zooming-function>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-10 columnMain">
        <div class="columnMainContent">
          <div class="title">
            <h4 class="textBlue">Search Results</h4>
          </div>
          <div
            class="searchResults d-flex justify-content-between align-items-start"
          >
            <div class="d-flex align-items-center">
              <div>
                <h5 class="result m-0 mr-2" style="display: inline-block">
                  Results
                </h5>
                <span class="textBold">{{
                  $store.getters.searchSettings.total
                    ? ($store.getters.searchSettings.page - 1) * 10 || 1
                    : 0
                }}</span>
                to
                <span class="textBold">{{
                  $store.getters.searchSettings.page *
                    $store.getters.searchSettings.perPage >
                  $store.getters.searchSettings.total
                    ? $store.getters.searchSettings.total
                    : $store.getters.searchSettings.page *
                        $store.getters.searchSettings.perPage || 10
                }}</span>
                of
                <span class="textBold">{{
                  $store.getters.searchSettings.total
                }}</span>
                for
                <span class="textBold">{{
                  $store.getters.searchSettings.searchKey
                }}</span>
              </div>
            </div>
            <div v-if="$store.getters.searchSettings.total" class="card-footer">
              <base-pagination
                align="end"
                :total="$store.getters.searchSettings.total"
                :perPage="$store.getters.searchSettings.perPage"
                :pageCount="pageCount"
                :value="$store.getters.searchSettings.page"
                @input="changePage"
              ></base-pagination>
            </div>
          </div>
          <p class="clear"></p>
          <div id="quranOutput">
            <div class="key" ref="top"></div>
            <div v-if="$store.getters.searchSettings.results.length">
              <single-ayah
                v-for="(result, index) in $store.getters.searchSettings.results"
                :key="index"
                :surah="result.surah"
                :ayah="result"
                :bg="true"
                :allowAllTrans="true"
                :hightLightText="true"
                @scrollToTop="topUpAction"
                @changeSurah="changeSurah"
              ></single-ayah>
            </div>
            <div
              v-else
              class="d-flex justify-content-center align-items-center"
              style="position: relative"
            >
              <img
                v-if="
                  !$store.getters.loader &&
                  !$store.getters.searchSettings.results.length
                "
                src="@/assets/images/no-data-img1.png"
                alt=""
              />
            </div>
          </div>
          <div
            class="searchResults d-flex justify-content-end align-items-center"
          >
            <div v-if="$store.getters.searchSettings.total" class="card-footer">
              <base-pagination
                align="end"
                :total="$store.getters.searchSettings.total"
                :perPage="$store.getters.searchSettings.perPage"
                :pageCount="pageCount"
                :value="$store.getters.searchSettings.page"
                @input="changePage"
              ></base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/apiList";
import SurahSelection from "../ClientSurahViewComponents/SurahSelection";
import ZoomingFunction from "../ClientSurahViewComponents/ZoomingFunction";
import TranslationChecks from "../ClientSurahViewComponents/TranslationChecks";
import SingleAyah from "../ClientSurahViewComponents/SingleAyah";

String.prototype.toAr = function () {
  return this.replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
};
export default {
  components: {
    SurahSelection,
    ZoomingFunction,
    TranslationChecks,
    SingleAyah,
  },
  data() {
    return {
      componentKey: 0,
    };
  },
  methods: {
    async fetchSearchResults() {
      let query = `page=${this.$store.getters.searchSettings.page}&perPage=${this.$store.getters.searchSettings.perPage}`;
      let getRes = await api.searchInQuran(query, {
        search:
          this.$store.getters.searchSettings.searchKey ||
          this.$route.query.query,
      });
      if (!getRes.response) {
        let object = {
          results: getRes.data.data.result,
          total: getRes.data.data.total,
        };
        this.$store.dispatch("searchInQuran", object);
      } else {
        let object = {
          results: [],
          total: 0,
          page: 1,
          perPage: 10,
        };
        this.$store.dispatch("searchInQuran", object);
      }
      this.$store.dispatch("toggleLoader", false);
    },

    changeSurah(surahNum) {
      this.page = 1;
      this.surahAyahs = [];
      this.totalResults = 0;
      this.$router.push({ path: "/" + surahNum });
    },

    changePage(value) {
      this.$store.dispatch("toggleLoader", true);
      let object = { page: value };
      this.$store.dispatch("searchInQuran", object);
      this.fetchSearchResults();
      this.topUpAction();
    },

    topUpAction() {
      var element = this.$refs["top"];
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
  },
  computed: {
    pageCount() {
      let pageCount =
        this.$store.getters.searchSettings.total /
        this.$store.getters.searchSettings.perPage;
      if (pageCount > 0) {
        return Math.ceil(pageCount);
      } else {
        return 0;
      }
    },
  },
  mounted() {
    this.fetchSearchResults();
  },
  beforeRouteUpdate(to, from, next) {
    this.surahNum = to.params.surahNum;
    from.params.surahNum = to.params.surahNum;
    next();
  },
  beforeDestroy() {
    let object = {
      results: [],
      total: 0,
      searchKey: null,
      page: 1,
      perPage: 10,
    };
    this.$store.dispatch("searchInQuran", object);
    // document.getElementById("search").value = "";
  },
};
</script>
<style lang="scss">
$global_color: #4c709b;
$global_color_lit: #4c709bcc;

.complete_surah_cont {
  scroll-behavior: smooth !important;

  @media screen and (max-width: 1110px) and (min-width: 962px) {
    & {
      max-width: 1000px;
      overflow-x: hidden;
      padding: 0px 10px;
    }
  }
  @media screen and (max-width: 962px) {
    & {
      max-width: 920px;
      overflow-x: hidden;
    }
  }
  @media screen and (max-width: 768px) {
    & {
      max-width: auto;
      overflow-x: hidden;
      padding: 0px 10px;
      .row {
        .columnMain {
          padding-left: 0px;

          #quranOutput {

            img {
              width: 70%;
            }
          }
        }
      }
    }
  }
}

.columnLeftSub {
  padding-bottom: 10px;

  .columnLeftContent {
    padding: 10px 10px 10px 10px;
    background-color: #fff;
    border-radius: 5px;
  }
}
.columnMain {
  padding: 0px;
  padding-left: 10px;
  min-height: 82.5vh;

  .columnMainContent {
    background-color: #fff;
    padding: 5px 15px 10px 15px;
    font-size: 12px;
    line-height: 18px;
    // min-height: 481px;
    border-radius: 5px;

    .textBlue {
      color: $global_color !important;
    }
  }

  h1 {
    font-size: 18px;
    color: #0099ff;
    margin: 0px;
    font-weight: normal;
  }

  .title {
    height: 25px;
    z-index: 2;

    h1 {
      float: left;

      .subAr {
        font-size: 22px;
        font-weight: 600;
      }
    }
  }

  p.clear {
    margin: 0px;
    padding: 5px 0px 5px 0px;
  }

  #quranOutput {
    line-height: normal;
    padding-bottom: 5px;

    a,
    object {
      outline: none;
    }
  }

  .giveMeEllipsis {
    white-space: nowrap;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
  }
}

.loadMore {
  font-weight: 600;
  // color: #0099ff;
  color: -webkit-linear-gradient(#32b597, #b53e32) !important;
  font-size: 14px;
  font-family: system-ui;
}

.searchResults {
  &:first-child {
    padding: 5px 0px 2px 0px;
    // background: linear-gradient(#4c709b00, #4c709b66);
    // border-bottom: 1px solid #eee;
    box-shadow: 0 1px 0 #eee;
  }

  .card-footer {
    border: none !important;
    padding: 0px !important;
    background: transparent !important;

    .pagination {
      margin: 0px !important;

      .page-item {
        &:hover {
          cursor: pointer !important;
        }

        &.active {
          .page-link {
            color: rgb(45, 206, 137) !important;
            font-weight: 600;
            background-color: transparent !important;
          }
        }
      }

      .page-link {
        padding: 0px !important;
        border: none !important;
        box-shadow: none !important;
        background-color: transparent !important;

        width: 15px;
        height: 15px;
        padding: 10px;
      }

      span:hover,
      i {
        cursor: pointer !important;
      }
    }
  }
}
</style>